import { isDefined } from '@pflegia/util/functions/type-guards';

import { BaseFunnelAnswers, BaseFunnelQuestion, BaseFunnelJobTitle, FunnelJobTitleAnswer } from '../types';

/**
 * Returns true if `answers[key]` has been answered.
 */
export const isAnswered = <J extends BaseFunnelJobTitle = BaseFunnelJobTitle, A extends BaseFunnelAnswers<J> = BaseFunnelAnswers<J>>(
  answers: A,
  key: keyof A,
): boolean => {
  switch (key) {
    case BaseFunnelQuestion.PositionDesired: {
      const answer = answers[key] as FunnelJobTitleAnswer[];
      return Boolean(answer?.length);
    }

    default:
      return isDefined(answers[key]);
  }
};
